import { Typography, TypographyProps } from '@mui/material';

export const PageTitle = ({ children, ...props }: TypographyProps) => (
  <Typography {...props} variant="h3">
    {children}
  </Typography>
);
